import { render } from "./NewProductCard.vue?vue&type=template&id=1a3c2e74&scoped=true"
import script from "./NewProductCard.vue?vue&type=script&lang=js"
export * from "./NewProductCard.vue?vue&type=script&lang=js"

import "./NewProductCard.vue?vue&type=style&index=0&id=1a3c2e74&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3c2e74"]])

export default __exports__